export default {
  campanha: {
    listOptions: [],
    value: null,
    selectedList: []
  },
  dataCriacaoInicial: {
    value: '',
    required: false,
    state: null
  },
  dataCriacaoFinal: {
    value: '',
    required: false,
    state: null
  },
  dataEnvioInicial: {
    value: '',
    required: false,
    state: null
  },
  dataEnvioFinal: {
    value: '',
    required: false,
    state: null
  },
  canalId: {
    listOptions: [
      {value: 1, text: 'EMAIL'},
      {value: 2, text: 'SMS'},
      {value: 3, text: 'WHATSAPP'}
    ],
    value: null,
    selectedList: []
  },
  modeloId: {
    listOptions: [],
    value: null,
    selectedList: []
  },
  listaId: {
    listOptions: [],
    value: null,
    selectedList: []
  },
  situacaoId: {
    listOptions: [
      {value: 1, text: 'PENDENTE'},
      {value: 2, text: 'ENVIANDO'},
      {value: 3, text: 'ENVIADO'},
      {value: 4, text: 'CONCLUÍDO'}
    ],
    value: null,
    selectedList: []
  }
}



// WEBPACK FOOTER //
// ./src/views/private/reports/campanha/campanhaGeral/search/search-form.js